export default __webpack_public_path__ + "static/media/logo192.0c080cbd.png";